<template>
  <el-table v-if="cutView=='shipment'" stripe border style="width: 100%" height="100%" size="mini"
    :data="tableData">
    <el-table-column type="index" align="center"
      :width="pagination.endIndex >= 1000 ? 80 : 50"
      :index="pagination.beginIndex"
    ></el-table-column>
    <el-table-column min-width="120px"
      label="交货单号" align="center" prop="allowSkip" show-overflow-tooltip>
      <template slot-scope="scope">
        <span class="allowSkip" @click="clickAllowSkip(scope.row)">
          {{ scope.row.likpVbeln ? scope.row.likpVbeln : '-' }}
        </span>
      </template>
    </el-table-column>
    <el-table-column min-width="80px" 
      label="销售组织" prop="likpVkorg" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <el-tooltip v-if="scope.row.likpVkorgTxt" :content="scope.row.likpVkorgTxt" class="item" effect="dark" placement="top" :open-delay="300">
          <span>{{scope.row.likpVkorg ? scope.row.likpVkorg : '-'}}</span>
        </el-tooltip>
        <span v-else>{{scope.row.likpVkorg ? scope.row.likpVkorg : '-'}}</span>
      </template>
    </el-table-column>
    <el-table-column min-width="120px" 
      label="客户名称" prop="adrcName1" align="center" show-overflow>
      <template slot-scope="scope">
        <el-tooltip v-if="scope.row.adrcName1" :content="scope.row.adrcName1" class="item" effect="dark" placement="top" :open-delay="300">
          <span class="textOverflow">
            {{ scope.row.adrcName1 ? scope.row.adrcName1 : '-' }}
          </span>
        </el-tooltip>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column min-width="80px" 
      label="计划日期" prop="likpWadat" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.likpWadat ? scope.row.likpWadat : '-'}}</span>
      </template>
    </el-table-column>
    <el-table-column min-width="80px" 
      label="送达方" prop="likpKunnr" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span v-if="scope.row.likpKunnr">
          {{ scope.row.likpKunnr }}
        </span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column min-width="80px" 
      label="售达方" prop="likpKunag" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>
          {{ scope.row.likpKunag ? scope.row.likpKunag : '-'}}
        </span>
      </template>
    </el-table-column>
    <el-table-column min-width="80px" 
      label="装运点" prop="likpVstel" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.likpVstel ? scope.row.likpVstel : '-'}}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import {
  apiSapShipmentOrderSearch
} from "@/api/SapOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
    cutView:null,
    searchConditionForm:{type: Object},
    pagination:{}
  },
  computed: {
  },
  components: {
  },
  created() {
  },
  data() {
    return {
      dialogTitle: "【未命名】",
      dialogForm: {
      },
      tableData:null,
      dialogRules: {},
      labelWidth: this.$store.state.labelWidth
    };
  },
  methods: {
    clickAllowSkip(row) {
      this.$parent.cutDetail = "shipmentDetail";
      this.$parent.nowRowData = row;
      this.$parent.tabPaneValue = row.id;
      let tabPaneIds = this.$parent.tabPaneList2.map((item) => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.$parent.tabPaneList2.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.$parent.tabPaneList2.push(row);
      }
    },
    async onSearch(callback) {
      this.tableData = [];
      const res = await apiSapShipmentOrderSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      });
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;        
        if (callback) {callback();}
      }
    }
  }
};
</script>